'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Api = require('../api/Api');

var _Api2 = _interopRequireDefault(_Api);

var _ModelCollection2 = require('./ModelCollection');

var _ModelCollection3 = _interopRequireDefault(_ModelCollection2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class ModelCollectionProperty
 *
 * @description
 * A ModelCollectionProperty instance is a ModelCollection that is a property of
 * a model instance. ModelCollectionProperties can be operated on independently of
 * the Model that owns them.
 */
var ModelCollectionProperty = function (_ModelCollection) {
    _inherits(ModelCollectionProperty, _ModelCollection);

    /**
     * @constructor
     *
     * @param {Model} parentModel The `Model` of the parent of this `ModelCollectionProperty`
     * @param {ModelDefinition} modelDefinition The `ModelDefinition` that this `ModelCollection` property is for
     * @param {Model[]} values Initial values that should be added to the collection property
     * @param {Api} api The class to use for API calls
     *
     * @description
     *
     * Creates a new `ModelCollectionProperty` object. This is a subclass of `ModelCollection`, which adds logic
     * for handling adding and removing elements to the collection and saving the changes to the API.
     */
    function ModelCollectionProperty(parentModel, modelDefinition, values, api) {
        _classCallCheck(this, ModelCollectionProperty);

        // Dirty bit
        var _this = _possibleConstructorReturn(this, (ModelCollectionProperty.__proto__ || Object.getPrototypeOf(ModelCollectionProperty)).call(this, modelDefinition, values, undefined));

        _this.dirty = false;
        // Keep track of added and removed elements
        _this.added = new Set();
        _this.removed = new Set();

        _this.api = api;

        // Store the parent model of this collection so we can construct the URI for API calls
        _this.parentModel = parentModel;
        return _this;
    }

    /**
     * @method add
     *
     * @param {Model} value Model instance to add to the collection.
     * @returns {ModelCollectionProperty} Returns itself for chaining purposes.
     *
     * @description
     * Calls the `add` method on the parent `ModelCollection` class, and then performs checks to keep track of
     * what, if any, changes that have been made to the collection.
     */


    _createClass(ModelCollectionProperty, [{
        key: 'add',
        value: function add(value) {
            if (this.valuesContainerMap.has(value.id)) {
                return this;
            }

            _get(ModelCollectionProperty.prototype.__proto__ || Object.getPrototypeOf(ModelCollectionProperty.prototype), 'add', this).call(this, value);

            if (this.removed.has(value.id)) {
                this.removed.delete(value.id);
            } else {
                this.added.add(value.id);
            }

            this.updateDirty();
            return this;
        }

        /**
         * @method remove
         *
         * @param {Model} value Model instance to remove from the collection.
         * @returns {ModelCollectionProperty} Returns itself for chaining purposes.
         *
         * @description
         * If the collection contains an object with the same id as the `value` parameter, that object is removed
         * from the collection. Checks are then performed to keep track of what, if any, changes that have been
         * made to the collection.
         */

    }, {
        key: 'remove',
        value: function remove(value) {
            _ModelCollection3.default.throwIfContainsOtherThanModelObjects([value]);
            _ModelCollection3.default.throwIfContainsModelWithoutUid([value]);

            if (this.delete(value.id)) {
                if (this.added.has(value.id)) {
                    this.added.delete(value.id);
                } else {
                    this.removed.add(value.id);
                }
            }

            this.updateDirty();
            return this;
        }

        /**
         * @method updateDirty
         *
         * @returns {boolean} True if the collection has changed, false otherwise.
         *
         * @description
         * Checks whether any changes have been made to the collection, and updates the dirty flag accordingly.
         */

    }, {
        key: 'updateDirty',
        value: function updateDirty() {
            this.dirty = this.added.size > 0 || this.removed.size > 0;
            return this.dirty;
        }

        /**
         * @method resetDirtyState
         *
         * @description
         * Sets dirty=false and resets the added and removed sets used for dirty state tracking.
         */

    }, {
        key: 'resetDirtyState',
        value: function resetDirtyState() {
            this.dirty = false;
            this.added = new Set();
            this.removed = new Set();
        }

        /**
         * @method isDirty
         *
         * @returns {boolean} true if any elements have been added to or removed from the collection
         */

    }, {
        key: 'isDirty',
        value: function isDirty() {
            return this.dirty;
        }

        /**
         * @method save
         *
         * @returns {Promise} A `Promise`
         *
         * @description
         * If any changes have been made to the collection, these changes will be submitted to the API. The returned
         * promise will resolve successfully when the changes have been saved to the API, and will be rejected if
         * either the changes weren't saved or if there were no changes to save.
         */

    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            // Calling save when there's nothing to be saved is a no-op (not an error)
            if (!this.isDirty()) {
                return Promise.resolve({});
            }

            var url = [this.parentModel.href, this.modelDefinition.plural].join('/');
            var data = {
                additions: Array.from(this.added).map(function (id) {
                    return { id: id };
                }),
                deletions: Array.from(this.removed).map(function (id) {
                    return { id: id };
                })
            };

            return this.api.post(url, data).then(function () {
                _this2.resetDirtyState();
                return Promise.resolve({});
            }).catch(function (err) {
                return Promise.reject('Failed to alter collection:', err);
            });
        }

        /**
         * @method create
         *
         * @param {Model} parentModel
         * @param {ModelDefinition} modelDefinition
         * @param {Model[]} values
         * @returns {ModelCollectionProperty}
         *
         * @description
         * See `ModelCollectionProperty.constructor`.
         */

    }], [{
        key: 'create',
        value: function create(parentModel, modelDefinition, values) {
            return new ModelCollectionProperty(parentModel, modelDefinition, values, _Api2.default.getApi());
        }
    }]);

    return ModelCollectionProperty;
}(_ModelCollection3.default);

exports.default = ModelCollectionProperty;
//# sourceMappingURL=ModelCollectionProperty.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/ModelCollectionProperty.js
// module id = 487
// module chunks = 0